import { useEffect, useState } from 'react';

function readIsDarkMode(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.classList.contains('dark');
}

/**
 * Tracks whether the `dark` class is present on `<html>`, updating reactively
 * via a MutationObserver instead of reading `classList` once during render
 * (which misses subsequent theme toggles).
 */
export function useIsDarkMode(): boolean {
  const [isDark, setIsDark] = useState<boolean>(readIsDarkMode);

  useEffect(() => {
    const root = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(root.classList.contains('dark'));
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
